export const getRouterBasename = (): string | undefined => {
	let base = import.meta.env.BASE_URL || '/';

	// normalize: ensure leading slash, strip trailing (except root), handle './'
	if (base === './' || base === '.') base = '/';
	if (!base.startsWith('/')) base = `/${base}`;
	if (base.length > 1 && base.endsWith('/')) base = base.slice(0, -1);

	return base === '/' ? '' : base;
};
